import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import type { ApiError, ApiResponse } from "../../../types/apiResponse";
import { createConcept } from "../api/createConcept";
import type { ConceptData } from "../types";

export const useCreateConcept = (): UseMutationResult<ApiResponse, ApiError, ConceptData> => {
    return useMutation({
        mutationFn: createConcept
    })
}
